module.exports = __webpack_public_path__ + "static/media/fed-anti-piracy.f7c112a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/security/fed-anti-piracy.png
// module id = 556
// module chunks = 0